<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='600px' center
             @close='dialogClose' :close-on-click-modal='false'>
    <div class='company'>
      <el-form :model='formData' label-width='120px' :rules='rules' ref='ruleForm'>
        <div-border label='基础信息'>
          <el-row>
            <el-col>
              <el-form-item label='供应商类型：' prop='suppliesTypes' style='margin-top: 15px'>
                <el-checkbox-group v-model="formData.suppliesTypes">
                  <el-checkbox :label="1">公路供应商</el-checkbox>
                  <el-checkbox :label="2">水路供应商</el-checkbox>
                  <el-checkbox :label="3">港口</el-checkbox>
                  <el-checkbox :label="4">其他</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item v-if="formData.suppliesTypes.includes('1')" label='服务区域：'
                            prop='serviceRegionId'>
                <el-cascader
                  size='mini'
                  ref='checkServe'
                  v-model='formData.serviceRegionId'
                  class='specialSelect'
                  :options='regionList'
                  collapse-tags
                  :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: true,
                      }"
                  style='width:100%'
                  clearable
                  filterable
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='登录账号：' prop='account' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.account'
                  placeholder='请输入登录账号(手机号)'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='登录密码：' prop='password' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.password'
                  placeholder='请输入登录密码'
                  autocomplete='off'
                  size='small'
                  show-password
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='供应商全称：' prop='name' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.name'
                  placeholder='请输入供应商全称'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='供应商简称：' prop='shortName' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.shortName'
                  placeholder='请输入供应商简称'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='关键词：' prop='keyword' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.keyword'
                  placeholder='请输入关键词'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='详情地址：' prop='address' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.address'
                  placeholder='请输入详情地址'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label='物流属性：' style='margin-top: 15px'>
                <el-radio-group v-model='formData.logisticsAttribute'>
                  <el-radio :label='0'>民生</el-radio>
                  <el-radio :label='1'>非民生</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='邮箱：' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.mailBox'
                  placeholder='请输入邮箱'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='电话：' style='margin-top: 15px'>
                <el-input
                  :style="'width:100%'"
                  v-model='formData.phone'
                  placeholder='请输入电话'
                  autocomplete='off'
                  size='small'
                />
              </el-form-item>
            </el-col>
            <div v-for='(item,index) in formData.person' :key='index'>
              <el-col :span='12'>
                <el-form-item label='对接人姓名：' :prop='`person.${index}.name`'
                              :rules='rules.name2'
                              style='margin-bottom: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='item.name'
                    placeholder='请输入对接人姓名'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='对接人电话：' :prop='`person.${index}.tell`'
                              :rules='rules.tell'>
                  <el-input
                    :style="'width:100%'"
                    v-model='item.tell'
                    placeholder='请输入对接人电话'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='对接人职位：' :prop='`person.${index}.position`'
                              :rules='rules.position' style='margin-bottom: 17px'>
                  <div style='display:flex;align-items:center;'>
                    <el-input
                      :style="'width:40%'"
                      v-model='item.position'
                      placeholder='请输入对接人职位'
                      autocomplete='off'
                      size='small'
                    />
                    <div style='display:flex;align-items:center;margin-left: 25px;'
                         v-if='index===formData.person.length-1'>
                      <el-button
                        style='margin-left: 10px;height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                        size='mini'
                        type='info'
                        icon='el-icon-plus'
                        circle
                        @click='levelAdd'
                      />
                      <el-button
                        v-if='formData.person.length!==1'
                        style='height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                        size='mini'
                        type='info'
                        icon='el-icon-minus'
                        circle
                        @click='levelMinus'
                      />
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
        </div-border>
        <div class='btnContainer'>
          <el-button class='searchBtn' size='medium' :loading='submitLoading' @click='submit'>确认
          </el-button>
          <el-button class='resetBtn' size='medium' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { supplierSynchronize } from "@/service/basicfile";
import divBorder from '@/components/divBorder';
import { getSessionStore } from "@/config/mUtils";

export default {
  name: "complete",
  components: {
    divBorder,
  },
  data() {
    const validateTell = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入对接人联系手机号'));
      } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {
      if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
        callback(new Error('请输入正确登录账号'));
      } else {
        callback();
      }
    };
    return {
      dialogTitle: '完善',
      dialogVisible: false,
      submitLoading: false,
      regionList: [],
      formData: {
        suppliesTypes: [],
        serviceRegionId: '',
        account: '',
        password: '',
        name: '',
        shortName: '',
        keyword: '',
        address: '',
        mailBox: '',
        phone: '',
        logisticsAttribute: 0,
        person: [
          {
            name: '',
            tell: '',
            position: '',
          },
        ]
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入供应商全称',
            trigger: 'blur',
          },
        ],
        suppliesTypes: [
          {
            required: true,
            message: '请选择供应商类型',
            trigger: 'blur',
          },
        ],
        serviceRegionId: [
          {
            required: true,
            message: '请选择服务区域',
            trigger: 'blur',
          },
        ],
        account: [
          {
            required: true,
            message: '请输入登录账号',
            trigger: 'blur',
          },
          {
            required: true,
            validator: validateAccount,
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur',
          },
        ],
        shortName: [
          {
            required: true,
            message: '请输入供应商简称',
            trigger: 'blur',
          },
        ],
        keyword: [
          {
            required: true,
            message: '请输入供应商关键词',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入详情地址',
            trigger: 'blur',
          },
        ],
        name2: [
          {
            required: true,
            message: '请输入对接人姓名',
            trigger: 'blur',
          },
        ],
        tell: [
          {
            required: true,
            validator: validateTell,
            trigger: 'blur',
          },
        ],
        position: [
          {
            required: true,
            message: '请输入对接人职位',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  async mounted() {
    this.regionList = JSON.parse(getSessionStore('areaList'));
  },
  methods: {
    /**
     * 提交
     */
    submit() {
      console.log(this.formData);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let leader = '',
            leaderPhone = '',
            leaderPosition = '';
          for (let i = 0; i < this.formData.person.length; i++) {
            if (i !== this.formData.person.length - 1) {
              leader += this.formData.person[i].name + ',';
              leaderPhone += this.formData.person[i].tell + ',';
              leaderPosition += this.formData.person[i].position + ',';
            } else {
              leader += this.formData.person[i].name;
              leaderPhone += this.formData.person[i].tell;
              leaderPosition += this.formData.person[i].position;
            }
          }
          this.submitLoading = true;
          const {
            status,
            message,
          } = await supplierSynchronize({ ...this.formData, leader, leaderPhone, leaderPosition });
          this.submitLoading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.dialogClose();
          this.$emit('completeSuccess')
        }
      });
    },
    /**
     * 打开弹出框
     */
    dialogOpen(data) {
      this.dialogVisible = true;
      this.formData = { ...this.formData, ...data }
    },
    /**
     * 关闭弹出框
     */
    dialogClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    /**
     * 添加对接人
     */
    levelAdd() {
      this.formData.person.push({
        name: '',
        tell: '',
        position: '',
      });
    },
    /**
     * 删除对接人
     */
    levelMinus() {
      this.formData.person.pop();
    },
  }
}
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }

  .company {
    width: 100%;
    padding: 20px 10px;
    max-height: 70vh;
    overflow: auto;

    .unitContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 140px;
      margin-bottom: 5px;

      ::v-deep {
        .el-input__inner {
          border: 1px solid #DCDFE6;
        }
      }
    }

    .unitContainer2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 189px;
      margin-bottom: 5px;

      span {
        color: #606266;
        font-weight: 700;
      }

      ::v-deep {
        .el-input__inner {
          border: 1px solid #DCDFE6;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }

      .el-form-item {
        margin-bottom: 0;
      }
    }

    hr {
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
